import { Observable } from "../observable";
import "./sort.css";
class SortElement extends HTMLElement {
    static get observedAttributes() {
        return ["value", "field"];
    }

    #unsub?: Function;

    $state = new Observable({
        valueKey: "",
        valueAscending: false,
        field: "",
    });

    constructor() {
        super();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue) {
            switch (name) {
                case "value":
                    if (newValue) {
                        this.$state.broadcast((prev) => {
                            let ascending = true;
                            let key = newValue;
                            if (key.startsWith("-")) {
                                ascending = false;
                                key = newValue.slice(1);
                            }
                            return {
                                valueKey: key,
                                valueAscending: ascending,
                                field: prev.field,
                            };
                        });
                    } else {
                        this.$state.broadcast((prev) => ({
                            ...prev,
                            valueAscending: false,
                            valueKey: "",
                        }));
                    }
                    break;
                case "field":
                    this.$state.broadcast((prev) => ({
                        ...prev,
                        field: newValue,
                    }));
            }
        }
    }

    connectedCallback() {
        this.#unsub = this.$state.subscribe(
            ({ valueAscending, valueKey, field }) => {
                let icon = "sort";
                let nextHref = "";

                const paramsString = window.location.search;
                const searchParams = new URLSearchParams(paramsString);

                if (field === valueKey) {
                    if (valueAscending) {
                        icon = "sort-up";
                        searchParams.set("sort", "-" + valueKey);
                    } else {
                        icon = "sort-down";
                        searchParams.delete("sort");
                    }
                } else {
                    icon = "sort";
                    searchParams.set("sort", field);
                }

                nextHref = searchParams.toString();

                this.innerHTML = `
                <a class="bd-button bd-surface-10 bd-button-icon" href="?${nextHref}" bd-boost>
                    <bd-icon value="${icon}"></bd-icon>
                </a>
            `;
            },
            true,
        );
    }

    disconnectedCallback() {
        this.#unsub?.();
    }
}

customElements.define("bd-sort", SortElement);
